import { t } from "i18next";
import { Button } from "../button";

const RecorderControls = ({
  status,
  onPause,
  onResume,
  onStopAndSave,
}: {
  status: string;
  onPause: () => void;
  onResume: () => void;
  onStopAndSave: () => void;
}): JSX.Element => {
  return (
    <div className="w-full flex gap-4 justify-center items-center">
      {status === "recording" ? (
        <Button
          aria-label="Pausar"
          className="w-[150px] font-bold"
          size="lg"
          onClick={onPause}
        >
          {t("components.recorderControls.pauseButton")}
        </Button>
      ) : status === "paused" ? (
        <Button
          aria-label="Reanudar"
          className="w-[150px] font-bold"
          size="lg"
          onClick={onResume}
        >
          {t("components.recorderControls.resumeButton")}
        </Button>
      ) : null}
      <Button
        aria-label="Stop and Save"
        className="w-[150px] font-bold"
        size="lg"
        variant={"destructive"}
        onClick={onStopAndSave}
      >
        {t("components.recorderControls.stopAndSaveButton")}
      </Button>
    </div>
  );
};

export default RecorderControls;
